import request from '@/utils/ajax';

export function addOss(data){
  return request({
    url: `/wx/manage/forwardStrategy/list`,
    method: 'get',
    params: data
  });
}

export function queryTypeList(data){
  return request({
    url: `/wx/manage/forwardStrategy/list`,
    method: 'get',
    params: data
  });
}

export function saveArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/save`,
    method: 'post',
    data: data
  });
}

export function updateArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/update`,
    method: 'put',
    data: data
  });
}

export function deleteArticle(data){
  return request({
    url: `/wx/manage/spiderArticle/delete`,
    method: 'post',
    data: data
  });
}



export function rulesList(data){
  return request({
    url: `wx/manage/spiderArticlePublish/list`,
    method: 'get',
    params: data
  });
}
